var $, _,DOMPurify;
if (typeof module === 'object' && module.exports) {
	var fetch = require('cross-fetch');
	var _ = require('underscore');
	var DOMPurify = require('dompurify')
}

var Client = function Client(alternateHost, alternateProtocol) {
	var self = this;
	self.sharedHeaders = {};
	self.responseHandlers = [];

	self.alternateHost = alternateHost;
	self.alternateProtocol = alternateProtocol;
	self.errorHandler = function(error) {
		// Placeholder
		return Promise.reject(error)
	}

	function sanitizeParams(jsonString) {
		if (!jsonString){ return jsonString }
		// Parse JSON string into an object
		let jsonObject = JSON.parse(jsonString);
		// Define a recursive function to clean strings in nested structures
		function cleanValue(value) {
			if (typeof value === 'string') {
				return DOMPurify.sanitize(value);
			} else if (Array.isArray(value)) {
				return value.map(cleanValue);
			} else if (typeof value === 'object' && value !== null) {
				return Object.fromEntries(
					Object.entries(value).map(([key, val]) => [key, cleanValue(val)])
				);
			} else {
				return value;
			}
		}
		// Clean all string values
		let cleanedObject = cleanValue(jsonObject);
		// Convert back to JSON string
		let cleanedJSONString = JSON.stringify(cleanedObject);
		return cleanedJSONString;
	}

	function getUrlBase() {
		var protocol = self.alternateProtocol || "https";
		var host = self.alternateHost || "api.savvashortondev.com";
		return protocol + "://" + host;
	}

	// Adds an Authorization header to send along with any
	//   requests through using this instance of the client
	self.addAuth = function(value) {
		self.sharedHeaders["Authorization"] = value;
	}
	self.removeAuth = function() {
		delete self.sharedHeaders["Authorization"];
	}
	self.addResponseHandler = function(handler) {
		self.responseHandlers.push(handler);
	}
	self.resetResponseHandlers = function(value) {
		self.responseHandlers = [];
	}
	self.setErrorHandler = function(handler) {
		self.errorHandler = handler;
	}

	// api.postAccessTokens((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postAccessTokens = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/access_tokens";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getActivities((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getActivities = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/activities";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postActivities((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postActivities = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/activities";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getActivity(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getActivity = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/activities/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchActivity(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchActivity = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/activities/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteActivity(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteActivity = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/activities/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAdmins((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAdmins = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/admins";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postAdmins((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postAdmins = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/admins";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAdmin(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAdmin = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/admins/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchAdmin(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchAdmin = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/admins/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteAdmin(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteAdmin = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/admins/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnalyzeClassResults((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnalyzeClassResults = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/analyze/class_results";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnalyzeGroupInsights((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnalyzeGroupInsights = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/analyze/group_insights";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnalyzeIndividualInsights((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnalyzeIndividualInsights = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/analyze/individual_insights";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnalyzeProgress((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnalyzeProgress = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/analyze/progress";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnalyzeSkillsets((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnalyzeSkillsets = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/analyze/skillsets";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnswers((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnswers = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/answers";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postAnswers((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postAnswers = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/answers";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAnswer(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAnswer = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/answers/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchAnswer(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchAnswer = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/answers/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteAnswer(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteAnswer = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/answers/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAssignments((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAssignments = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/assignments";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postAssignments((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postAssignments = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/assignments";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAssignment(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAssignment = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/assignments/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchAssignment(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchAssignment = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/assignments/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteAssignment(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteAssignment = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/assignments/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAssignmentsCurrent((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAssignmentsCurrent = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/assignments/current";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getAvatar(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getAvatar = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/avatars/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchAvatar(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchAvatar = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/avatars/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postAwards((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postAwards = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/awards";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getBooks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getBooks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postBooks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postBooks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getBook(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getBook = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getBookNewsFeedItem(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getBookNewsFeedItem = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/books/{id}/news_feed_item";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverAccessTokens((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverAccessTokens = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_access_tokens";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverAccessToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverAccessToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_access_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchCleverAccessToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchCleverAccessToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_access_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverEvents((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverEvents = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_events";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverSections((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverSections = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_sections";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverSection(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverSection = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_sections/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchCleverSection(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchCleverSection = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_sections/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverUsers((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverUsers = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_users";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getCleverUser(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getCleverUser = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_users/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchCleverUser(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchCleverUser = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/clever_users/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getComments((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getComments = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/comments";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postComments((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postComments = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/comments";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getComment(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getComment = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/comments/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchComment(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchComment = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/comments/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteComment(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteComment = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/comments/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postContactMessages((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postContactMessages = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/contact_messages";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postDataExports((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postDataExports = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/data_exports";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDigests((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDigests = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/digests";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDiscountToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDiscountToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchDiscountToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchDiscountToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteDiscountToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteDiscountToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/discount_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDiscountTokens((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDiscountTokens = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/discount_tokens";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postDiscountTokens((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postDiscountTokens = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/discount_tokens";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDistrictOrgs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDistrictOrgs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/district_orgs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postDistrictOrgs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postDistrictOrgs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/district_orgs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDistrictOrg(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDistrictOrg = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/district_orgs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchDistrictOrg(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchDistrictOrg = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/district_orgs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteDistrictOrg(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteDistrictOrg = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/district_orgs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getDocRequest((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getDocRequest = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/doc_request";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getEvaluations((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getEvaluations = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/evaluations";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postEvaluations((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postEvaluations = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/evaluations";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getEvaluation(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getEvaluation = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/evaluations/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchEvaluation(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchEvaluation = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/evaluations/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postFeedbackItem((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postFeedbackItem = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/feedback_item";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchFeedbackItem(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchFeedbackItem = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/feedback_item/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getHello((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getHello = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/hello";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getLogs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getLogs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/logs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postLogs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postLogs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/logs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getLog(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getLog = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/logs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchLog(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchLog = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/logs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteLog(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteLog = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/logs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getNewsFeedItems((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getNewsFeedItems = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/news_feed_items";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getNewsFeedItem(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getNewsFeedItem = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/news_feed_items/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getNewsFeedItemComments(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getNewsFeedItemComments = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/news_feed_items/{id}/comments";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postNewsFeedItemComments(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postNewsFeedItemComments = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/news_feed_items/{id}/comments";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getNotifications((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getNotifications = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/notifications";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postParents((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postParents = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/parents";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getParent(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getParent = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/parents/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchParent(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchParent = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/parents/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postParentsLogins((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postParentsLogins = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/parents/logins";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getPatches((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getPatches = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/patches";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postPatches((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postPatches = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/patches";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getPasswordResets((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getPasswordResets = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/password_resets";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postPasswordResets((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postPasswordResets = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/password_resets";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getPerks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getPerks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/perks";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postPerks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postPerks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/perks";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getPhotographs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getPhotographs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/photographs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postPhotographs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postPhotographs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/photographs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getPhotograph(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getPhotograph = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/photographs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchPhotograph(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchPhotograph = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/photographs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deletePhotograph(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deletePhotograph = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/photographs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getQuestions((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getQuestions = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/questions";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postQuestions((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postQuestions = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/questions";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getQuestionsQuiz((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getQuestionsQuiz = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/questions/quiz";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getQuestion(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getQuestion = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/questions/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchQuestion(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchQuestion = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/questions/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteQuestion(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteQuestion = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/questions/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getQuizzes((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getQuizzes = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/quizzes";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postQuizzes((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postQuizzes = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/quizzes";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getQuiz(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getQuiz = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/quizzes/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchQuiz(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchQuiz = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/quizzes/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteQuiz(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteQuiz = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/quizzes/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getRatings((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getRatings = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/ratings";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postRatings((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postRatings = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/ratings";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getRating(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getRating = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/ratings/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchRating(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchRating = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/ratings/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteRating(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteRating = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/ratings/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getReadingLevels((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getReadingLevels = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/reading_levels";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postReadingLevels((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postReadingLevels = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/reading_levels";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getReferrals((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getReferrals = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/referrals";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postReferrals((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postReferrals = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/referrals";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getResponses((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getResponses = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postResponses((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postResponses = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getResponse(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getResponse = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchResponse(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchResponse = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteResponse(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteResponse = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getResponseNewsFeedItem(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getResponseNewsFeedItem = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses/{id}/news_feed_item";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getResponseLink(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getResponseLink = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/responses/{id}/link";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postQuoteRequest((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postQuoteRequest = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/quote_request";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postRosters((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postRosters = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/rosters";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postRostersParse((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postRostersParse = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/rosters/parse";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getStats((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getStats = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/stats";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getSchoolOrgs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getSchoolOrgs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/school_orgs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postSchoolOrgs((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postSchoolOrgs = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/school_orgs";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getSchoolOrg(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getSchoolOrg = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/school_orgs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchSchoolOrg(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchSchoolOrg = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/school_orgs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteSchoolOrg(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteSchoolOrg = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/school_orgs/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getSchools((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getSchools = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/schools";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postSchools((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postSchools = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/schools";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getSchool(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getSchool = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/schools/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchSchool(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchSchool = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/schools/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getStudentList(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getStudentList = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/student_lists/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchStudentList(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchStudentList = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/student_lists/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteStudentList(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteStudentList = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/student_lists/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getStudentLists((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getStudentLists = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/student_lists";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postStudentLists((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postStudentLists = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/student_lists";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getStudents((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getStudents = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postStudents((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postStudents = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchStudents((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchStudents = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getStudent(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getStudent = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchStudent(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchStudent = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteStudent(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteStudent = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postStudentsMerge((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postStudentsMerge = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/students/merge";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getSurveyPrompts((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getSurveyPrompts = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/survey_prompts";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getTags((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getTags = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tags";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postTags((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postTags = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tags";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteTag(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteTag = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tags/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getTasks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getTasks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tasks";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postTasks((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postTasks = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tasks";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getTask(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getTask = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tasks/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchTask(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchTask = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tasks/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteTask(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteTask = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/tasks/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getUpgradeToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getUpgradeToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.patchUpgradeToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.patchUpgradeToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "PATCH",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteUpgradeToken(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteUpgradeToken = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/upgrade_tokens/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getUpgradeTokens((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getUpgradeTokens = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/upgrade_tokens";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postUpgradeTokens((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postUpgradeTokens = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/upgrade_tokens";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postUserAlerts((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postUserAlerts = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/user_alerts";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.deleteUserAlert(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.deleteUserAlert = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/user_alerts/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "DELETE",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getUserNewsItems((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getUserNewsItems = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/user_news_items";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getUsers((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getUsers = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/users";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getUser(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getUser = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/users/{id}";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getUserTrigger(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getUserTrigger = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/users/{id}/trigger";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postUserTrigger(id, (primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postUserTrigger = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/users/{id}/trigger";
	// url += ".json";

	url = url.replace('{id}', arguments[0]);

	var primaryParamsIndex = 1;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.getWidgetDigests((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.getWidgetDigests = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/widget_digests";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = true;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "GET",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postWidgetDigestsTrigger((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postWidgetDigestsTrigger = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/widget_digests/trigger";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

// api.postWritingGrade((primary_parameters), (additional_parameters))

//   primary_parameters added to query for GET or DELETE and body for POST and PATCH\n
//   optional additional_parameters: { query: {}, body: {}, headers: {}, form: {} }
//   returns: promise of json data

self.postWritingGrade = function() {
	var data = null;
	var queryParams = {};
	var headerParams =  { "content-type": "application/json" };
	// var postBinaryBody = null;

	var url = getUrlBase() + "/api/v1/grade_writing";
	// url += ".json";

	url = url;

	var primaryParamsIndex = 0;
	var primaryParamsAsData = false;

	if (primaryParamsAsData) {
		_.extend(queryParams, arguments[primaryParamsIndex]);
	} else {
		data = JSON.stringify(arguments[primaryParamsIndex]);
	}

	var extraParameters = arguments[primaryParamsIndex + 1];

	if (extraParameters && extraParameters["form"] && (extraParameters["body"] || data)) {
		throw "can't submit both form and body data"
	}

	if (extraParameters != null) {
		if (extraParameters["query"]) {
			_.extend(queryParams, extraParameters["query"]);
		}

		if (extraParameters["header"]) {
			_.extend(headerParams, self.sharedHeaders, extraParameters["header"]);
		}

		if (extraParameters["body"]) {
			data = JSON.stringify(extraParameters["body"]);
		}

		if (extraParameters["form"]) {
			// Unimplemented, something to do with form data
		}

	}
	_.extend(headerParams, self.sharedHeaders);

	url += createQueryString(queryParams);

	var options = {
		method: "POST",
		body: sanitizeParams(data),
		headers: headerParams
	};

	var promise = fetch(url, options);

	_.each(self.responseHandlers, function(handler) {
		promise = promise.then(handler)
	});

	return promise.then(function(response) { return response.json(); }).catch(self.errorHandler)
}

}

function createQueryString(queryParams) {
	var queryString ='';
	var i = 0;
	for (var queryParamName in queryParams) {
		if (i == 0) {
			queryString += '?' ;
		} else {
			queryString += '&' ;
		}
		
		queryString += queryParamName + '=' + encodeURIComponent(queryParams[queryParamName]);
		i++;
	}
	
	return queryString;
}

// export module for Node.js
if (typeof module === 'object' && module.exports) {
	module.exports = Client;
}



// WEBPACK FOOTER //
// ./modules/wr_apis/apis/wr_client_api/node_package/src/client.js